import { Globals } from "@ortho-next/three-base";
import { OrthographicCamera } from "three";
/**
 * An orthographic camera with z set to 5000 and the width fixed to 200 and heigth based on the window aspect ratio.
 */
export class CustomCamera extends OrthographicCamera {
    constructor() {
        const width = 200;
        const aspectRatio = Globals.canvasContainer.clientWidth / Globals.canvasContainer.clientHeight;
        const height = width / aspectRatio;
        super(width / -2, width / 2, height / 2, height / -2, 0.1, 10000);
        this.position.z = 5000;
        this.updateProjectionMatrix();
    }
    /**
     * Get height.
     */
    get height() {
        return this.top - this.bottom;
    }
    /**
    * Get width.
    */
    get width() {
        return this.right - this.left;
    }
    setZoom(value) {
        this.zoom = value;
        this.updateProjectionMatrix();
        this.needsRender = true;
    }
}
//# sourceMappingURL=CustomCamera.js.map